import { SatisfactionDTO } from '@/models/Satisfaction';

export interface SatisfactionState {
    societes: [],
    societeIdSelectionnee: number,
    satisfaction?: SatisfactionDTO
}

export const state = (): SatisfactionState => ({
    societes: [],
    societeIdSelectionnee: 0,
    satisfaction: undefined,
});
